import { render, staticRenderFns } from "./IndexAside.vue?vue&type=template&id=07f4c5bc"
import script from "./IndexAside.vue?vue&type=script&lang=js"
export * from "./IndexAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports